















































/* tslint:disable:only-arrow-functions*/

import Vue from 'vue';
import Component from 'vue-class-component';
import getFileSizeHumanReadable from '@/util/file-size';
import AnimatedInput from '@/components/AnimatedInput.vue';
import Browsercheck from '@/components/Browsercheck.vue';
import wait from "@/util/wait";
import {Action, Getter, Mutation} from "vuex-class";
import KeyUtility from "../util/keyUtility";
import Base64Encoder from "../util/base64encoder";

@Component({
    components: { Browsercheck },
})
export default class Home extends Vue {
    // Tell the IDE that the mapped getters and setters exist...
    @Mutation setFileDragActive!: () => void;
    @Mutation setFileDragInactive!: () => void;
    @Mutation startOverWithUpload!: () => void;
    @Mutation setFile!: (file: File) => void;
    @Mutation setUploadPassword!: (password: string) => void;
    @Mutation setUploadUsesPassword!: (state: boolean) => void;
    @Mutation setUploadFile!: (file: File) => void;
    @Mutation setMetaKey!: (metaKey: CryptoKey) => void;
    @Mutation setPasswordSalt!: (passwordSalt: Uint8Array) => void;
    @Mutation addUploadFile!: (file: File) => void;


    @Getter isLoggedIn!: boolean;
    @Getter showUploadForm!: boolean;
    @Getter showUploadProgress!: boolean;
    @Getter showUploadSuccess!: boolean;
    @Getter showUploadError!: boolean;
    @Getter hasUploadFile!: boolean;

    @Action uploadMetadata!: (letterboxAddress: string | null) => Promise<any>;
    @Action uploadChunks!: () => Promise<any>;
    @Action commitUpload!: (neededForDecryption: string) => Promise<any>;

    eventcount: number = 0;
    animateProgress: boolean = true;
    agreesToS: boolean = false;

    get usesPassword() {
        return this.$store.state.upload.usesPassword;
    }

    set usesPassword(password) {
        this.setUploadUsesPassword(password);
    }

    get password() {
        return this.$store.state.upload.password;
    }

    set password(password) {
        this.setUploadPassword(password);
    }

    get progress() {
        return this.$store.state.upload.progress;
    }

    dragAndDropActive() {
        return this.$store.state.showFileDragActive;
    }

    chooseFile() {
      const ref: any = this.$refs.uploadFiles as HTMLInputElement;
      const files = ref.files;

      for (const file of files) {
        this.checkForDuplicatesAndAddFile(file);
      }

      this.$router.push("/upload");
    }

  checkForDuplicatesAndAddFile(file: File) {
    const idx: number = (this.$store.state.upload.files as File[]).findIndex((f: File) => {
      return f.name === file.name;
    });

    if (idx > -1) {
      this.$swal('Gleiche Dateinamen', 'Du kannst keine zwei Dateien versenden, die den gleichen Namen tragen.', 'error');
    } else {
      this.addUploadFile(file);
    }
  }

  //Drag & Drop setup:
  dragEnterHandler(e: DragEvent) {
    e.preventDefault();
    this.eventcount++;
    this.setFileDragActive();
    return false;
  }

  dragLeaveHandler(e: DragEvent) {
    e.preventDefault();
    // Check if Dragleave is really a leave or just a leave for one container:
    this.eventcount--;
    if (this.eventcount === 0) {
      this.setFileDragInactive();
    }
    return false;
  }

  dragOverHandler(e: DragEvent) {
    e.preventDefault();
  }

  dropHandler(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.$log.debug("Drop event in Home Route registered", e);
    //Clear state of upload form:
    this.eventcount = 0;
    this.setFileDragInactive();
    if (!e.dataTransfer) {
      return false;
    }
    if (e.dataTransfer.files) {
      for (const file of e.dataTransfer.files) {
        this.checkForDuplicatesAndAddFile(file);
      }
    } else { //Weird, it should contain files, but lets search manually!
      for (const item of e.dataTransfer.items) {
        if (item.kind === "file") {
          const f: File | null = item.getAsFile();
          if (f) {
            this.checkForDuplicatesAndAddFile(f);
          }
        }
      }
    }
    this.$router.push("/upload");
    return false;
  }

  mounted() {
      this.$nextTick(() => {
        this.agreesToS = this.isLoggedIn;
      });

      //Clear state of upload form:
      this.startOverWithUpload();

      window.addEventListener('dragenter', this.dragEnterHandler, false);
      window.addEventListener('dragleave', this.dragLeaveHandler, false);
      window.addEventListener('dragover', this.dragOverHandler, false);
      window.addEventListener('drop', this.dropHandler, false);
    }

    beforeDestroy() {
      window.removeEventListener('dragenter', this.dragEnterHandler, false);
      window.removeEventListener('dragleave', this.dragLeaveHandler, false);
      window.removeEventListener('dragover', this.dragOverHandler, false);
      window.removeEventListener('drop', this.dropHandler, false);
    }
}
